import { Dispatch, SetStateAction, useState } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import StarIcon from "@mui/icons-material/Star";
import { Modal, Button } from "@mui/material";
import { useReplyRatingMutation } from "../service/rating";
import toast from "react-hot-toast";

interface ModalProps {
    open: boolean;
    onClose: () => void;
    setOpen: Dispatch<SetStateAction<boolean>>;
    selectedItem?: any;
    onSuccess?: () => void;
}

export default function AddRatingReply({ open, onClose, setOpen, selectedItem, onSuccess }: ModalProps) {
    const [addReplyRating, { isLoading: isAdding }] = useReplyRatingMutation();
    const [reply, setReply] = useState("");

    const handleSubmit = async () => {
        if (!reply.trim()) {
            toast.error("Reply is required");
            return;
        }
        try {
            const body = {
                reply: reply,
            };

            const response = await addReplyRating({body,id:selectedItem?.id}).unwrap();

            if (response.statusCode === 200 || response.statusCode === 201) {
                toast.success("Reply added successfully");
                setReply("");
                onClose();
                onSuccess?.();
            } else {
                toast.error(response.message || "Something went wrong");
            }
        } catch (error: any) {
            toast.error(error?.data?.message || "An error occurred");
            console.error(error);
        }
    };

    return (
        <Modal className="modal addReply_modal" open={open} onClose={onClose}>
            <div className="modal-dialog">
                <div className="modal-body">
                    {/* Title Bar */}
                    <div className="modal_title">
                        <h2>Add Reply</h2>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={() => setOpen(false)}
                        >
                            <CloseIcon />
                        </button>
                    </div>

                    {/* Rating & Review Section */}
                    <div className="view_page gap_p">
                        <div className="w_100">
                            <h6>Rating</h6>
                            <p>
                                {selectedItem?.rating || 0} <StarIcon sx={{ color: "#FFC107", fontSize: 18 }} />
                            </p>
                        </div>

                        <div className="w_100">
                            <h6>Review</h6>
                            <p>
                                {selectedItem?.review || "No review available"}
                            </p>
                        </div>
                    </div>

                    {/* Reply Section */}
                    <div className="form">
                        <div className="control_group">
                            <label htmlFor="add-reply-input">Add Reply</label>
                            <TextField
                                placeholder="Enter Reply"
                                fullWidth
                                hiddenLabel
                                multiline
                                minRows={4}
                                value={reply}
                                onChange={(e) => setReply(e.target.value)}
                                inputProps={{ id: "add-reply-input" }}
                            />
                        </div>

                        {/* Footer Buttons */}
                        <div className="footer_btn_flex">
                            <Button
                                className="btn btn_primary"
                                onClick={handleSubmit}
                                disabled={isAdding}
                            >
                                {isAdding ? "Submitting..." : "Submit"}
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
}